module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "ch3",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Title-ct",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "8",
      "id": "pg_8",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROAD TO THE NATIONAL ACADEMY OF SCIENCES, WASHINGTON, D.C.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Sayer drove through the sparkling tunnel of holiday lights along 14th Street. As she neared the scene, she called FBI data analyst and computer wizard, Ezra Coen.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ez, you heard about the murders in D.C.? I’m lead and I want you in charge of coordinating the data.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I knew you’d need me and I’m already heading to the office to gather info as it trickles in. I’ll crunch everything into something coherent by the time you get here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Great. First thing, we’re going to need a small task force for this one. Get that approved and handpick a few field agents and analysts. Then I want you to focus on ID’ing our female victim. Sounds like she could be young.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Will do. Have them scan her prints and photo to me as soon as the medical examiner gets there.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You’re the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Damn straight I am,” Ezra said. “I actually just left in the middle of a date for this so you officially owe me. Your adulation can take the form of an invitation to Tino’s for dinner sometime soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Sayer let out a small laugh. “You drive a hard bargain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Always. See you when you get here.” He hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sayer was glad to see Ezra’s inner smart-ass emerging more and more every day. He had lost both of his legs in an explosion last year and the road to recovery was a rough one.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Across the National Mall, Sayer navigated her motorcycle onto Constitution Avenue and rolled past the cheerful glow of the National Christmas tree just as the sky cleared for the first time in a week. Something about the crisp air made the stars seem brighter than usual. Even the Milky Way made a rare appearance, arcing over the quiet city.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Winter in D.C. could be an endless slog of slushy rain and gray skies, but right now, between the stars, the powdery dusting of snow, and the glow of holiday lights, it felt like a fairy tale.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The illusion was shattered by the line of police cruisers along Constitution Avenue, their rolling lights creating a sharp red and blue strobe effect on the snow. All the action was on the southwestern corner of the grounds of the National Academy of Sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The corner that housed Sayer’s favorite memorial in all of D.C.—the Albert Einstein Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She parked and made her way through the small gaggle of onlookers, their eyes alight with the familiar combination of disgust and fascination. It was the same at every crime scene, people riveted by the excitement of death so close to their own beating hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A broad-shouldered D.C. police officer blocked her entry as she ducked under the police tape. “Whoa, lady. This is an active crime scene.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sayer realized how she must look, a damp, brown-skinned woman covered with road grit. “FBI, Senior Special Agent Altair.” She flipped open her badge.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No kidding, Agent Altair!” He smiled. “Now I recognize you. You worked with my cousin on that Cage Killer case, Wilson Tooby. I’m Joe Tooby.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "10",
      "id": "pg_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Sayer gave him a curt nod. “How’s Wilson doing these days?” she managed to squeeze out, not really wanting to make small talk.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He’s great. Retired last month. Spending time with his daughter before she leaves for college. Glad it’s you running this case. Detective Wyatt’s waiting to give you an update.” He gestured to a stout DCPD detective.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The hunched detective in a large puffy black jacket and a fuzzy red winter hat calmly jotted notes amid the chaos of the crime scene.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Welcome to hell, Agent Altair,” he said as she approached.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You must be Detective Wyatt.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He glanced up from his notes. His youthful round face was aged by a deeply rueful expression. “Heard a lot about you. Nice to finally meet you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m just sorry it’s under these circumstances.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("They both looked over at Officer Graham’s body.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So, what’ve we got?” Sayer said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Wyatt led her over to the body just off the sidewalk. The victim was sprawled on his back, police uniform torn open where the EMTs had tried to revive him. The edges of the blood pooled on the frozen ground around him were already drying in the cold.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Officer Frank Graham, seven years on the force. He was on the radio with dispatch when he saw someone painting what he thought was graffiti on the Einstein Memorial. Dispatcher said that he interrupted the person who then shot him without warning.” Wyatt’s voice fell low with emotion. “He bled out before EMTs could get here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sayer stood over the dead officer, heart beating painfully in her throat. “He have kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, one son, living with his ex-wife now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Damn.” She couldn’t help but remember getting the call about her fianc"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" Jake’s death. She knew exactly what it would feel like for his family to get the call tonight. She shut down the flash of grief that always hit when she thought about Jake and turned to scan the bloody "), _c('span', {
    attrs: {
      "aria-label": "11",
      "id": "pg_11",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("footprints ringing the body. She couldn’t tell if they belonged to the medics or the killer. Something for the evidence team to sort out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Grim-faced, Detective Wyatt led her toward the Einstein Memorial. “Second victim is why we called you in. Looks like she’s in her late teens. Definitely some ritual elements to the murder. I’ll let you take a look.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He left it vague and hung back. Sayer appreciated him giving her some space to form her own opinions.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She was drawn toward the statue. The twelve-foot sculpture of Einstein reclined on a curved bench of white stone, holding a book inscribed with three of the physicist’s famous equations.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“‘Joy and amazement of the beauty and grandeur of this world of which man can just form a faint notion,’” Sayer murmured her favorite Einstein quote like a talisman as she approached the memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The bronze figure looked down on a circular star map spread out before him. Almost thirty feet across, thousands of metal studs representing the planets, sun, moon, and stars sparkled on the expanse of lustrous granite.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("At the center of the celestial map, a heart-shatteringly small young woman lay on her back. The body was perfect, untouched other than a smear of blood across her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("During her career, Sayer had seen plenty of dead bodies and she was good at distancing herself from the horrors of death, but this display turned her stomach. Murder is usually violent, messy, so the purposeful perfection of the girl’s body felt wrong on a deeply instinctual level. Despite Sayer’s roiling stomach, she didn’t look away from the confusing scene.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A large axe was placed in the girl’s right hand. Along the white granite bench, the words “as above, so below” were painted in blood.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But the most unusual things at the scene were the nine carved figurines, each no more than a foot tall, crouched in a circle around the body. Sayer stepped closer to get a better look. The small statues had "), _c('span', {
    attrs: {
      "aria-label": "12",
      "id": "pg_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("sharp teeth protruding beneath short animal snouts. Their primate bodies hunched forward, humanlike, hands resting on their knees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nine baboons encircled the girl like an audience observing her in death.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba8887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0